'use client';

import { c as _c } from "react/compiler-runtime";
import markdownStyles from '../styles/markdown-styles.module.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeMeta from 'rehype-meta';
import rehypeRaw from 'rehype-raw';
import { markdownRenderers } from '../services/markdown-renderers';
import { useTheme } from 'next-themes';
import { Themes } from '@/types/theme';
import { cn } from '@/lib/utils';
import { useMounted } from '@/hooks/useMounted';
type postBodyTypes = {
  content: string;
  className?: string;
};
export default function PostBody(t0) {
  const $ = _c(12);
  const {
    className,
    content
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const mounted = useMounted();
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative mx-auto max-w-4xl prose dark:prose-invert", className, markdownStyles.markdown);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = mounted && resolvedTheme === Themes.DARK;
  let t3;
  if ($[2] !== t2) {
    t3 = markdownRenderers(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [remarkGfm, remarkMath];
    t5 = [rehypeKatex, rehypeMeta, rehypeRaw];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== content || $[7] !== t3) {
    t6 = <ReactMarkdown components={t3} remarkPlugins={t4} rehypePlugins={t5}>{content}</ReactMarkdown>;
    $[6] = content;
    $[7] = t3;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}